// TODO (jscheel): This belongs in the design system

import React, { useCallback } from 'react'
import { css } from '@emotion/react'
import { doSetFlag, selectFlag } from 'ducks/flags'
import { useSelector, useDispatch } from 'react-redux'
import { Message, Icon as SuiIcon } from 'util/ui'
import { Icon } from 'shared/ui'
import SpacedItems from 'shared/components/ui/SpacedItems'
import themeVars from 'ui_theme/site/globals/site.variables'

const iconStyle = () => theme => css`
  color: ${theme.color.primary.brand};
  margin: 0 10px;
  font-size: 16px;
  line-height: ${themeVars.lineHeight} !important;
  .outline {
    margin-right: 0 !important;
  }
  .info {
    font-size: 7px;
  }
`

const messageStyle = () => theme => css`
  color: ${theme.color.monochrome.black};
`

const MessageBox = ({
  dismissFlag,
  icon: iconName,
  children,
  content,
  ...rest
}) => {
  const hasSeenMessage = useSelector(selectFlag)(dismissFlag)

  // TODO (jscheel): Extract for re-use if message style is going to be used in multiple places.
  const dispatch = useDispatch()
  const closeMessage = useCallback(
    () => {
      dispatch(doSetFlag(dismissFlag))
    },
    [dispatch, dismissFlag]
  )

  if (dismissFlag && hasSeenMessage) return null

  return (
    <Message {...rest}>
      <SpacedItems.Container direction="horizontal">
        {iconName && (
          <SpacedItems.Item align="center">
            <SuiIcon.Group size="small" css={iconStyle}>
              <SuiIcon size="large" name="circle outline" />
              <SuiIcon size="small" name={iconName} />
            </SuiIcon.Group>
          </SpacedItems.Item>
        )}
        <SpacedItems.Item css={messageStyle} grow={1} shrink={1}>
          {content || children}
        </SpacedItems.Item>
        {dismissFlag && (
          <SpacedItems.Item>
            <Icon name="close" size="small" onClick={closeMessage} />
          </SpacedItems.Item>
        )}
      </SpacedItems.Container>
    </Message>
  )
}

export default MessageBox
